import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IMobileServiceResolverData, IMobileServiceType } from './mobile-services.interface';
import { XhrService } from '../../core/services/xhr-service/xhr.service';
import { API } from '../../global/API.constants';
import { concatMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { SegmentTypesEnum } from '../../global/global.enums';

@Injectable({
  providedIn: 'root',
})
export class MobileServicesResolver implements Resolve<IMobileServiceResolverData> {
  constructor(private xhr: XhrService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IMobileServiceResolverData> | Promise<IMobileServiceResolverData> | IMobileServiceResolverData {
    return this.xhr.get<IMobileServiceType[]>(API.services.list).pipe(
      concatMap((list) => {
        const defaultItem =
          list.find((item) => item.szegmens === SegmentTypesEnum.LAKOSSAGI && item.husegHonap === 10) ?? list[0];

        return <Observable<IMobileServiceResolverData>>this.xhr
          .get(API.services.mobile, {
            params: { husegHonap: defaultItem.husegHonap, szegmens: defaultItem.szegmens },
          })
          .map((services) => {
            return {
              availableList: list,
              services,
            };
          });
      })
    );
  }
}
